import { FullSalesOrderInfo, useSalesOrderList } from 'api';
import { useState } from 'react';

import { AutocompleteField, type AutocompleteFieldProps } from '../AutocompleteField/AutocompleteField';

export type SalesOrderAutocompleteProps = Omit<
  AutocompleteFieldProps<FullSalesOrderInfo>,
  'options' | 'defaultValue'
> & {
  defaultValue?: FullSalesOrderInfo['id'];
};

export const SalesOrderAutocomplete = ({ defaultValue, ...props }: SalesOrderAutocompleteProps) => {
  const [query, setQuery] = useState(defaultValue?.toString() || '');

  const { data, isLoading } = useSalesOrderList({
    search: query,
  });

  return (
    <AutocompleteField<FullSalesOrderInfo>
      options={data?.results || []}
      loading={isLoading}
      getOptionLabel={(item) => item.slug}
      isOptionEqualToValue={(option, value) => {
        return value === undefined || option?.id?.toString() === (value?.id ?? value)?.toString();
      }}
      valueField="id"
      filterOptions={(options, state) => {
        setQuery(state.inputValue);
        return options;
      }}
      data-testid="sales-order-autocomplete"
      {...props}
    />
  );
};
